export default {
  'forgetpassword.forgetpassword': 'نسيت كلمة المرور؟',
  'forgetpassword.wrongemail': 'البريد الإلكتروني غير صحيح',
  'forgetpassword.resetemail':
    'أدخل عنوان البريد الإلكتروني الذي استخدمته عند الانضمام وسنرسل لك تعليمات لإعادة تعيين كلمة المرور الخاصة بك.',
  'forgetpassword.description':
    'من أجل الأمان، لا نقوم بتخزين كلمة المرور الخاصة بك. لذا كن مطمئنًا بأننا لن نرسل كلمة المرور الخاصة بك عبر البريد الإلكتروني.',
  'forgetpassword.resetpassword': 'إعادة تعيين كلمة المرور',
};
